<template>
  <drag-drawer v-model="showDrawer"
                 :width.sync="width"
                 :min-width="minWidth"
                 :inner="true"
                 :transfer="false"
                 :placement="placementComputed"
                 :draggable="true"
                 @on-resize="handleResize"
                 @on-close="handleClose"
                 :scrollable="true">
      <div slot="header">
        <label>{{title}}</label>
      </div>
    <!--top-->
      <div>
        <el-input placeholder="意图名称" v-model="searchValue" class="input-with-select">
          <el-button type="primary" slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
        <span style="float:right;">
          <!--<el-button type="info">复制意图</el-button>-->
          <el-button type="primary" @click="handleAddIndent">新增意图</el-button>
        </span>
      </div>
    <!--table-->
    <div>
      <el-table
        :data="indentData"
        style="width: 100%"
      >
        <el-table-column align="center" :show-overflow-tooltip='true'
          property="name"
          label="意图名称">
        </el-table-column>
        <el-table-column align="center" :show-overflow-tooltip='true'
          label="用户话术">
          <template slot-scope="scope">
            <span v-for="(option,index) in scope.row.expressions" :key="index">{{option}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :show-overflow-tooltip='true'
          label="参数">
          <template slot-scope="scope">
            <p v-for="(option,index) in scope.row.params" :key="index">{{option}}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <!--弹窗-->
    <IndentDialog :indentId="indentId" :flowId="flowId" :show="showDialog" :isEdit="isEdit" @close="handleCloseDialog"></IndentDialog>
    </drag-drawer>
</template>

<script>
  import DragDrawer from "./dragDrawer/drag-drawer";
  import IndentDialog from "./IndentDialog";
  export default {
    name: "IndentDrawer",
    components: {IndentDialog, DragDrawer},
    props: ['indent', 'flowId'],
    data() {
      return {
        width: 600,
        minWidth: 600,
        title: '意图',
        placement: 'right',
        showDrawer: false,
        searchValue: '',
        indentData: [],
        indentId: '',
        showDialog: false,
        isEdit: false,
      }
    },
    methods: {
      initData(flowId) {
        let that = this
        let param = {rwId:flowId,name:this.searchValue}
        this.$http.post('/AI/FlowDetail/queryIndents',param).then(res=>{
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          this.indentData = response.obj
        })
      },
      searchData() {
        this.initData(this.flowId)
      },
      handleResize(event) {
        const {atMin} = event
        console.log(atMin)
      },
      handleClose(val) {
        this.$emit('closeDrawer', true)
      },
      handleEdit(index, row) {
        this.isEdit = true
        this.showDialog = true
        this.indentId = row.id
      },
      handleAddIndent() {
        this.isEdit = false
        this.showDialog = true
        this.indentId = ''
      },
      handleDelete(index, row) {
        let param = {
          rwId:this.flowId,
          purposeId: row.id,
          menuId:'a_2-8',
          journalType:'AI机器人管理=>流程绘制=>删除意图'
        }
        let that = this
        this.$Modal.confirm({
          title:'提示',
          content:'是否确认删除',
          onOk:()=>{
            that.$http.post('/AI/FlowDetail/deleteIndent',param).then(res=>{
              let response = res.data
              if (response.flag !== '666') {
                that.$alert(response.msg,'提示',{
                  confirmButtonText: '确定'
                })
                return false
              }
              that.$Message.info('删除成功')
              that.initData(that.flowId)
            })
          }
        })
      },
      handleCloseDialog(val) {
        this.showDialog = val
        if (!val) {
          this.initData(this.flowId)
        }
      }
    },
    computed: {
      placementComputed() {
        return this.placement ? 'left' : 'right'
      }
    },
    watch: {
      indent: {
        deep: true,
        immediate: true,
        handler(val) {
          if (val) {
            this.showDrawer = true
            if (this.flowId) {
              this.initData(this.flowId)
            }
          }
        }
      }
    }
  };
</script>

<style lang="css">
  .el-input-group {
    width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow/components/IndentDrawer.vue